<template>
  <v-sheet class="customer">
    <v-card-text class="px-0">
      <v-col md="12" class="px-0 pb-0 d-flex align-center justify-space-between">
        <div>
          <h2 class="custom-header-blue-text m-0">Utilities - {{ getDate()}} <v-chip tonal
              class="mr-2 text-light green"> {{ history?.length }} </v-chip></h2>
        </div>
        <v-btn class="ml-2 float-right" :disabled="pageLoading" depressed tile v-on:click="goBack()">
          Back
        </v-btn>
      </v-col>
    </v-card-text>


    <v-simple-table fixed-header class="bt-table table_height_supplier">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-for="heading in headers" :key="`_head_${heading.title}`" style="background-color: #f5f5f5">
              <div v-if="heading.status">
                <span v-if="heading.title === '#'">
                  <v-checkbox hide-details color="#0d47a1" class="m-0" v-model="supplier_selectedAll"></v-checkbox>
                </span>
                <span v-else> {{ heading.title }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="!pageLoading">
          <template v-if="history?.length">
            <tr v-for="(row, index) in history" :key="`$_${index + index * 5}_supplier_` + index"
              :class="index % 2 === 0 && 'blue lighten-5'" class="product-listing-tr">
              <td v-for="(th, index) in headers" :key="'key_' + index" class="cursor-pointer">
                <div v-if="th.key === 'action' && th.status">
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed fab dark x-small class="mx-2" color="green" v-bind="attrs" v-on="on"
                        v-on:click.stop.prevent="updatePayment(row)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed fab dark x-small color="red" v-bind="attrs" v-on="on"
                        v-on:click.stop.prevent="deleteConfirm(row)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </div>



                <div v-else-if="th.key === 'date' && th.status">
                  <v-chip tonal color="blue" class="text-light"> {{ formateUtidate(row.date) }}</v-chip>
 
                </div>

                <div v-else-if="th.key == 'utility_name' && th.status">

               
                  <span v-if="row.utility_name"> {{ row.utility_name }}</span>
                  <span v-if="!row.utility_name" class="text-muted" style="width: 250px">
                    No name
                  </span>

                </div>
                <div v-else-if="th.key === 'remark' && th.status">
                  <div v-if="row.remark" class="text-truncate" style="width: 250px">
                    {{ stripHtmlTags(row.remark) }}
                  </div>
                  <span v-if="row && row.remark && row.remark.length > 20"
                    style="color: #24326d; cursor: pointer; font-size: 12px" @click="
                      remarkPop(row.remark)
                    ">Read More</span>
                  <div v-if="!row.remark" class="text-muted" style="width: 250px">
                    No remark
                  </div>
                </div>
                <div v-else-if="th.key === 'amount' && th.status">

                  <div v-if="row.amount" style="width: 250px">
                    {{ formatMoney(row.amount) }}
                  </div>
                  <div v-else class="text-muted" style="width: 250px">
                    No Amount Provided
                  </div>
                </div>
                <div v-else-if="th.key === 'created_at' && th.status">
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-calendar</v-icon>
                      {{ formateUtidate(row.added_at) }}
                      <VTooltip activator="parent"> Created date </VTooltip>
                    </div>
                  </div>
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-clock</v-icon>
                      {{ formateTime(row.added_at) }}
                      <VTooltip activator="parent"> Created Time </VTooltip>
                    </div>
                  </div>
                </div>

              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="9">
                <p class="m-0 text-center">
                  <img width="30" :src="$assetURL('media/error/empty.png')" class="row-not-found-image mr-4" />
                  Uhh... There are no adjustment at the moment.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot v-else>
          <tr v-for="idr in 5" :key="`_$idr_key_${idr}`">
            <td v-for="idk in 5" :key="`_$idk_key_${idk}`">
              <v-skeleton-loader type="text"></v-skeleton-loader>
            </td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>

    <v-layout v-if="false && this.history?.length" class="light-border-top mt-4">
      <v-flex md6>
        <label class="btx-label p-4">Showing {{ showingFrom }} to {{ showingTo }} of {{ totalRows }} entries</label>
      </v-flex>
      <!-- {{ pageLimit }} -->
      <v-flex md6>
        <v-pagination color="blue darken-4" v-model="currentPage" :length="pageLimit" :total-visible="7"></v-pagination>
      </v-flex>
    </v-layout>
    <Dialog :dialog="dialog" :dialogWidth="900">
      <template v-slot:title>Desctiption</template>
      <template v-slot:body>
        <v-row class="delete-dialog">
          <v-col md="12" class="m-3 py-0 my-auto">
            <p class="btx-p m-0"><b class="red--text text--lighten-1"></b>{{ text }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="dialog = false"> Close </v-btn>
      </template>
    </Dialog>
    <DeleteTemplate type="Utility" :delete-text="deleteText" delete-note="" :delete-dialog="deleteDialog"
      :delete-endpoint="deleteEndpoint" v-on:close="deleteDialog = false" v-on:delete:success="refresh()">
    </DeleteTemplate>

    <Dialog :dialog="addialog">
      <template v-slot:title >
        {{ dialogTitle }}
      </template>
      <template v-slot:body>
        <v-container fluid class="pt-0">
          <v-form ref="paymentTypeForm" v-model.trim="formValid" lazy-validation
            v-on:submit.stop.prevent="updateOrCreate()">
            <v-row>
              <v-col md="12">
                <v-layout>
                  <v-flex md4 class="my-auto">
                    <label for="payment-name" class="btx-label mt-2 required">Payment Type</label>

                  </v-flex>
                  <v-flex md8>
                    <v-radio-group row hide-details v-model="payment.type">
                      <template v-for="(_radio, idx) in payment_type_radio">
                        <v-radio :disabled="pageLoading" :id="_radio.value"
                          :key="'$_' + _radio.title + '_' + _radio.value + '_' + idx" color="#0d47a1" :style="`border: 1px solid ${
                                  payment.type === _radio.value ? '#0d47a1' : '#dedcdc'
                                } !important;`" :class="[
                                  'px-4',
                                  'py-2',
                                  'rounded-xl',
                                  { 'blue lighten-5': payment.type === _radio.value },
                                ]" :value="_radio.value">
                          <template v-slot:label>
                            <label :for="_radio.value" class="field-label">
                              {{ _radio.title }}
                            </label>
                          </template>
                        </v-radio>
                      </template>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                <v-layout>
<v-flex md4>
                  <label for="payment-utility_name" class="btx-label mt-2 required">Name</label>
                </v-flex>
                <v-flex md8>
                  <TextInput
                    hide-details
                    v-model="payment.utility_name"
                    :disabled="pageLoading"
                    :loading="pageLoading"
                    id="payment-utility_name"
                    placeholder="Name"
                    :rules="[vrules.required(payment.utility_name, 'Name')]"
                  ></TextInput>
                </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md4 class="my-auto">
                    <label for="amount" class="btx-label mt-2 required"> Amount</label>
                  </v-flex>
                  <v-flex md8>
                    <CurrencyInput hide-details v-model="payment.amount"
                      :rules="[vrules.required(payment.amount, 'Amount')]" :class="{ required: !payment.amount }"
                      :disabled="pageLoading" :loading="pageLoading" id="amount" placeholder="Amount"></CurrencyInput>

                  </v-flex>

                </v-layout>
<!-- 
                <p class="text-error">You can enter amount as 0.</p> -->


                <v-layout>
                  <v-flex md4 class="my-auto">
                    <label for="expiry-date" class="btx-label mt-2 required">Payment Date</label>
                  </v-flex>
                  <v-flex md8>
                    <DatePicker clearable hide-details v-model="payment.date" :disabled="pageLoading"
                      :loading="pageLoading" :rules="[vrules.required(payment.date, 'Payment Date')]" id="expiry-date"
                      placeholder="Utiliy Payment Date"></DatePicker>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md4>
                    <label for="promotion-remark" class="btx-label mt-2">Remark</label>
                  </v-flex>
                  <v-flex md8>
                    <TextAreaInput hide-details v-model="payment.remark" :disabled="pageLoading" :loading="pageLoading"
                      id="payment-remark" placeholder="Remark" :counter-value=250></TextAreaInput>
                  </v-flex>
                </v-layout>
              </v-col>

            </v-row>
          </v-form>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn :disabled="pageLoading || !formValid" :loading="pageLoading" class="white--text mr-2" depressed
          color="blue darken-4" tile v-on:click="updateOrCreate()">
          Save
        </v-btn>
        <v-btn :disabled="pageLoading" depressed tile v-on:click="clearVars()"> Cancel </v-btn>
      </template>
    </Dialog>
  </v-sheet>
</template>
<script>
import { FIND_UTILITY_PAYMENT } from "@/core/lib/payment.lib";
import { toSafeInteger } from "lodash"; 
import { SET_ERROR } from "@/core/services/store/common.module"; 
import DeleteTemplate from "@/view/components/DeleteTemplate";
import moment from "moment-timezone";
import { formatMoney } from "accounting-js";
import {  UPDATE_PAYMENT } from "@/core/lib/payment.lib";
import { SET_MESSAGE } from "@/core/services/store/common.module";
import Dialog from "@/view/components/Dialog";
import DatePicker from "@/view/components/DatePicker";
import CurrencyInput from "@/view/components/CurrencyInput";
import TextAreaInput from "@/view/components/TextAreaInput";
import TextInput from "@/view/components/TextInput";  

export default { 
  data() {
    return {  
      payment_type_radio: [ 
        { title: "Utility", value: "2" },
      ],
      addialog:false,
       dialogTitle: "Add Utiliy",
      dataLoading: false,
      updateMode: false,
      payment: {
        type: '1', 
        utility_name: null,
        remark: null,
        date: null,
        amount: null,
   
      },     
      paymentId: null,
      text: '',
   
      formValid: true,
      dialog:false,
      deleteText: '',
      deleteDialog: false,
      deleteEndpoint: "",
      history: [],
      search: null,
      historyTab: "all",
      pageLoading: false,
      promotionDetails: [],
      headers: [
        { title: 'Action', key: 'action', status: true },
        { title: 'Date', key: 'date', status: true }, 
        { title: 'Name', key: 'utility_name', status: true},
        { title: 'Remark', key: 'remark', status: true },
        { title: 'Amount', key: 'amount', status: true, align: 'right' },
        { title: 'Created at', key: 'created_at', status: true, align: 'right' }
      ]
    };
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
         
        if (to.query.month && to.query.year) { 
          this.findPayment(to.query.month,to.query.year);
        } else {
        this.goBack();
      }
        this.pageLoading = true;
      }
    },
    historyTab() {
      this.refresh()
    },
    currentPage() {
      this.refresh()
    },
    listingSearch() {
      this.refresh()
    },
    dialog(param) {
      if (param) {
        this.refresh()
      }
    },
  },
  computed: {
  
    dialogWidth() {
      return toSafeInteger((document.body.clientWidth / 100) * 80);
    },
  },
  methods: {
    remarkPop(reason, image) {
      this.text = reason;
      this.images = image;

      this.dialog = true;
    },
    formatMoney(money) {
      return formatMoney(money, {
        symbol: "RM",
        decimal: ".",
        thousand: ",",
        precision: 2,
        format: "%s%v",
      });
    },
    getDate(){
     return this?.history[0]?.month_name + ' ' + this?.history[0]?.year
    },
    deleteConfirm({ code, id }) { 
      this.deleteText = code;
      this.deleteEndpoint = `payment-types/${id}`;
      this.deleteDialog = true;
    },
    clearVars() {
      this.addialog = false;
      this.paymentId = null;
      this.dialogTitle = "Add Utiliy";
    
      this.deleteDialog = false;
      this.deleteText = null;
      this.deleteEndpoint = null;
      this.updateMode= false,
      this.payment = {
         type: '1',
         remark: null,
         date: null,
         amount: null,
        
      };
    },
    updatePayment(row) {  
      this.addialog = true;
      this.paymentId = row.id;
      this.dialogTitle = `Update Utiliy - ${row.utility_name}`;
      this.updateMode = true;
      this.payment = {
         type: row.type.toString(),
         utility_name: row.utility_name,
         remark: row.remark,
         date: row.date,
         amount: row.amount,
      };
  
    },  
    formateTime(param) {
      return moment(param).format("hh:mm A");
    },

    closeDialog() {
      this.history = [];
      this.search = null;
      this.historyTab = "all";
      this.pageLoading = false;
      this.$emit("close", true);
    },
    stripHtmlTags(content) { 
      const tempElement = document.createElement('div');
      tempElement.innerHTML = content; 
      return tempElement.textContent || tempElement.innerText || '';
    },
    formatedate(param) {      return moment(param).format("DD/MM/YYYY hh:mm A");
    },
    formateUtidate(param) {      return moment(param).format("DD/MM/YYYY");
  },
    async findPayment(m,y) {
    
        try {
          this.pageLoading = false;
          const historys = await FIND_UTILITY_PAYMENT(m,y, {
            search: this.search,
            tab: this.historyTab,
          });
          this.history = historys.rows; 
        } catch (error) {
          this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
        } finally {
          this.pageLoading = false;
        }
      },
      async updateOrCreate() {
      const _this = this;

      if (!_this.$refs.paymentTypeForm.validate()) {
        return false;
      }

      try {
        _this.pageLoading = true;

        if (_this.paymentId) {
          await UPDATE_PAYMENT(_this.paymentId, _this.payment);
          _this.clearVars();
          _this.findPayment(this.$route.params.month,this.$route.params.year);
          _this.$store.commit(SET_MESSAGE, [
            { model: true, message: "Utiliy Updated Successfully." },
          ]);
        } 
      } catch (error) {
        console.log(error,"error");
        
        // Handle direct string error message
        const errorMessage = typeof error === 'string' ? error : "Something went wrong. Please try again later";
        _this.$store.commit(SET_ERROR, [
          { model: true, message: errorMessage },
        ]);
      } finally {
        _this.pageLoading = false;
      }
    },
    refresh(){ 
          if(this.$route.params && this.$route.params.month && this.$route.params.year){
      this.findPayment(this.$route.params.month,this.$route.params.year); 
    }else{
      this.findPayment(this.$route.query.month,this.$route.query.year);
    }
  }
  },
 
  mounted() { 
    if(this.$route.params.month && this.$route.params.year){
      this.findPayment(this.$route.params.month,this.$route.params.year); 
    } 
     
  },
  components: {
    DeleteTemplate,
    Dialog,
    TextAreaInput,
    CurrencyInput,
    DatePicker,
    TextInput,
  },
};
</script>
